import { getHomeSpaceMetaPills } from '@app/utils/mapHomeSpaceToCard';

type SpaceWithDates = {
  startDate?: string;
  endDate?: string;
};

export const getAssignmentTermLabel = (
  space: SpaceWithDates | null | undefined
): string | null => {
  if (!space) {
    return null;
  }

  const { dateRange } = getHomeSpaceMetaPills(space.startDate, space.endDate);
  const startYear = space.startDate
    ? new Date(space.startDate).getFullYear()
    : null;
  const endYear = space.endDate ? new Date(space.endDate).getFullYear() : null;

  let academicYearLabel: string | null = null;

  if (startYear && endYear) {
    academicYearLabel =
      startYear === endYear ? `${startYear}` : `${startYear}-${endYear}`;
  } else if (startYear || endYear) {
    academicYearLabel = `${startYear || endYear}`;
  }

  return [academicYearLabel, dateRange].filter(Boolean).join(' | ') || null;
};
